import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9072 0.779647C10.7699 0.646297 10.5829 0.571289 10.3879 0.571289C10.1929 0.571289 10.0059 0.646297 9.8686 0.779647L4.41966 6.0344L2.13037 3.82262C1.93904 3.64017 1.66061 3.57092 1.40148 3.64133C1.14234 3.71174 0.942549 3.91093 0.878446 4.16278C0.814343 4.41463 0.895835 4.68023 1.09178 4.85807L3.90036 7.56293C4.0377 7.69628 4.22464 7.77129 4.41966 7.77129C4.61468 7.77129 4.80162 7.69628 4.93895 7.56293L10.9072 1.8151C11.0573 1.68175 11.1426 1.49404 11.1426 1.29737C11.1426 1.10071 11.0573 0.912999 10.9072 0.779647Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
};

export default Svg;
